'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var _excluded = ["className", "cookiePermission", "headline", "id", "lazy", "style"];
var CLASSNAME = 'varta-youtube-embed',
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnIframe = "".concat(CLASSNAME, "__iframe");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function YoutubeEmbed(_ref) {
  var className = _ref.className,
      cookiePermission = _ref.cookiePermission,
      headline = _ref.headline,
      id = _ref.id,
      lazy = _ref.lazy,
      style = _ref.style,
      data = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var query = Object.keys(data).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
  }).join('&');
  query = query ? "?".concat(query) : '';
  var host = cookiePermission ? 'https://www.youtube.com' : 'https://www.youtube-nocookie.com';
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(style), style))
  }, headline && /*#__PURE__*/React__default.createElement("h2", null, headline), /*#__PURE__*/React__default.createElement("div", {
    className: cnWrapper
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: cnIframe,
    src: "".concat(host, "/embed/").concat(id).concat(query),
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    loading: lazy ? 'lazy' : ''
  })));
}
YoutubeEmbed.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  cookiePermission: PropTypes.bool,

  /** */
  headline: PropTypes.string,

  /** */
  id: PropTypes.string.isRequired,

  /** */
  lazy: PropTypes.bool,

  /** */
  style: PropTypes.oneOf(['light', 'dark'])
};
YoutubeEmbed.defaultProps = {
  lazy: true
};

module.exports = YoutubeEmbed;
